import styled from 'styled-components';

//import bgFooter from '~/assets/bg-section-footer.png';
//import ilustraFooter from '~/assets/ilustra-03.png';
import iconPhone from '~/assets/icon-phone.png';
import iconWhatsapp from '~/assets/icon-whatsapp.png';

export const Container = styled.section`
  position: relative;
  background-color: #fff;

  background-position: bottom center;
  background-repeat: no-repeat;
  /* padding: 20px 15px 1100px; */
  padding: 20px 15px 110px;
  &:before {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 120px;
    margin-top: -120px;
  }
  /*style do accordion*/
  .accordion {
    width: 100%;
  }
  [data-toggle="collapse"] {
	.fa {
		position: absolute;
		right: 15px;
		&:before {
			content: "\f077";
		}
	}
}
[data-toggle="collapse"].collapsed {
	.fa {
		position: absolute;
		right: 15px;
		&:before {
			content: "\f078";
		}
	}
}
.btn-link {
	font-size: 26px;
	color: #17a2b8;
	font-weight: 700;
  text-align: left !important;  
}
.card {
	margin-bottom: 10px;
	border-top-right-radius: 15px !important; 
}
.card-body {
	font-size: 24px;  
}
.accordion {
	.card-body {
		p {
			font-size: 20px !important;
			padding: 0;
			strong {
				font-weight: 600;
			}
		}
		h4 {
			font-size: 22px !important;
			font-weight: 600;
		}
	}  
}

.card-header {
	border-top-right-radius: 20px !important;
}

  /*style do accordion end*/
`;

export const Inner = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 1680px;
  padding: 0 30px; /* display: flex; */
  & > h2 {
    flex: 0 0 100%;
    text-align: center;
    color: #27357c;
    font-size: 50px;
    font-weight: 900;
    text-shadow: 2px 2px 0 #a8dff4;
    /* padding-right: 60px; */
    padding-bottom: 30px;
    span {
      //display: block;
      text-align: left;
      color: #831d13;
    }
  }
  & > div {
    font-size: 28px;
    line-height: 46px;
    p {
      padding: 0 0 5px;
      color: #545353;
      a {
        color: #27357c;
        font-weight: 700;
        text-decoration: underline;
      }
      &.phone {
        padding-left: 55px;
        background: url(${iconPhone}) left center no-repeat;
        background-size: auto 70%;
        &.whatsapp {
          background: url(${iconWhatsapp}) left center no-repeat;
          background-size: auto 60%;
        }
      }
    }
  }
  @media (max-width: 870px) {
    flex-direction: column;
    padding-left: 15px;
    padding-right: 15px;
    & > h2 {
      text-align: left;
      padding: 0 0 35px;
      font-size: calc(100vw / 15);
      * {
        text-align: left !important;
      }
    }
    & > div {
      font-size: calc(100vw / 35);
    }
  }
  @media (max-width: 550px) {
    h2 {
      font-size: 30px;
    }
    & > div {
      font-size: 16px;
      line-height: 40px;
    }
  }
  /* .accordion {
    border: solid 1px red;
  } */
`;

export const Sign = styled.div`
  position: absolute;
  z-index: 10;
  bottom: 0;
  right: 0;
  color: #63afe2;
  font-size: 17px;
  letter-spacing: -0.24px;
  margin: 20px;
`;

export const Br = styled.br``;
